import {CityList} from "./CityList";
import {CityEdit} from "./CityEdit";
import {CityCreate} from "./CityCreate";

export default {
    list: CityList,
    create: CityCreate,
    edit: CityEdit
};
